import React from "react";
import forEach from "lodash/forEach";
import { observer } from "mobx-react";
import isUndefined from "lodash/isUndefined";
import clientErrorLogger from "util/clientErrorLogger";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import isArray from "lodash/isArray";
import { ActionRootContext } from "./ActionRoot";

export default (Component, storeToPropMapping) => {
    @observer
    class Propulator extends React.Component {
        // All the keys of storeToPropMapping should be context stores

        static contextType = ActionRootContext;

        render() {
            let mappedProps = {};
            /**
             *  storeToPropMapping: {
             *      <storeName>: {
             *          <modelName1>: <modelAlias1>,
             *          <modelName2>: <modelAlias2>
             *      }
             *  }
             */

            forEach(storeToPropMapping, (modelMapping, storeName) => {
                const pascalizedStoreName = upperFirst(camelCase(storeName));

                forEach(modelMapping, (modelAlias, modelName) => {
                    const sourceName = isArray(modelMapping) ? modelAlias : modelName;

                    if (isUndefined(this.context[pascalizedStoreName]) || isUndefined(this.context[pascalizedStoreName][sourceName])) {
                        clientErrorLogger.notify("Propulator could not find prop", "warning", {
                            storeName: pascalizedStoreName,
                            modelName: sourceName
                        }, true);
                    } else {
                        mappedProps[modelAlias] = this.context[pascalizedStoreName][sourceName];
                    }
                });
            });

            return <Component {...mappedProps} {...this.props} dispatcher={this.context.dispatcher} />;
        }
    }

    return Propulator;
};
